import React, { Component } from 'react';
import DarkThemeNav from '../common/dark-theme-nav';

class Buttons extends Component {

  componentDidMount() {
    for (const buttonGroup of document.getElementsByClassName('btn-group')) {
      buttonGroup.addEventListener('apply.commonui.buttonGroup', this.logSelectedButtons.bind(this, buttonGroup), false);
    }
  }

  componentWillUnmount() {
    // Unbind all event listeners
    for (const buttonGroup of document.getElementsByClassName('btn-group')) {
      buttonGroup.removeEventListener('apply.commonui.buttonGroup', this.logSelectedButtons.bind(this, buttonGroup));
    }
  }

  logSelectedButtons(buttonGroup) {
    console.log('Button-Group-Item Toggled'); // eslint-disable-line no-console
    const buttonsArray = [];
    const selectedButtons = buttonGroup.querySelectorAll('input:checked');
    for (let i = 0; i < selectedButtons.length; i++) {
      buttonsArray.push(selectedButtons[i].id);
    }
    console.log(buttonsArray); // eslint-disable-line no-console
  }

  render() {
    return (
      <section><a className="anchor" id="buttons"></a>
      <h2>Buttons</h2>
      <h4>Basics</h4>
      <p>A basic button can be created with minimal markup. Because buttons can be used for many purposes, it&#39;s important to use the right tag.</p>
      <p>Use the <code>&lt;a&gt;</code> tag if the button is a link to another page, or a link to an anchor within a page. Generally anchors don&#39;t require JavaScript to work.
      <br/>Use the <code>&lt;button&gt;</code> tag if the button performs an action that changes something on the current page. <code>&lt;button&gt;</code> elements almost always require JavaScript to function.
      <br/>To create a button, add the <code>btn</code> class to any <code>&lt;a&gt;</code> or <code>&lt;button&gt;</code> or <code>&lt;input&gt;</code> element.
      <br/>In general you should use a <code>button</code> as is far more explicit, and comes along with aria accessibility features. Buttons can have <code>type="submit"</code> too.</p>

      <DarkThemeNav anchor="buttons" />

      <button className="btn">Button</button>&nbsp;
      <a className="btn">Button</a>&nbsp;
      <input type="button" className="btn" value="Button"/>&nbsp;
      <br/><br/>
      <pre><code className="language-html">{`<button class="btn">Button</button>
<a class="btn">Button</a>
<input type="button" class="btn" value="Button"/>`}</code></pre>
      <br/>
      <h4>Link Buttons</h4>

      <button className="btn btn--link">Link Button</button>
      <br/><br/>
      <pre><code className="language-html">{`<button class="btn btn--link">Link Button</button>`}</code></pre>
      <br/>
      <h4>Sizing</h4>
      <p>Add a <code>btn--small</code> or <code>btn--large</code> for different sized buttons.</p>

      <button className="btn btn--small push-quarter--ends">Small Button</button>&nbsp;
      <button className="btn push-quarter--ends">Normal Button</button>&nbsp;
      <button className="btn btn--large push-quarter--ends">Large Button</button>&nbsp;
      <br/>
      <br/><br/>
      <pre><code className="language-html">{`<button class="btn btn--small">Small Button</button>
<button class="btn">Normal Button</button>
<button class="btn btn--large">Large Button</button>`}</code></pre>
      <br/>
      <h4>Coloring - Full Color</h4>

      <button className="btn push-quarter--ends">Primary Button</button>&nbsp;
      <button className="btn btn--positive push-quarter--ends">Positive Button</button>&nbsp;
      <button className="btn btn--negative push-quarter--ends">Negative Button</button>&nbsp;
      <button className="btn btn--secondary push-quarter--ends">Secondary Button</button>&nbsp;
      <button className="btn btn--secondary blue-label push-quarter--ends">Secondary Blue Button</button>&nbsp;
      <br/><br/>

      <pre><code className="language-html">{`<button class="btn">Primary Button</button>
<button class="btn btn--positive">Positive Button</button>
<button class="btn btn--negative">Negative Button</button>
<button class="btn btn--secondary">Secondary Button</button>
<button class="btn btn--secondary blue-label">Secondary Blue Button</button>`}</code></pre>
      <br/>

      <h4>Coloring - Outline Color</h4>

      <button className="btn btn--outline push-quarter--ends">Primary Button</button>&nbsp;
      <button className="btn btn--positive btn--outline push-quarter--ends">Positive Button</button>&nbsp;
      <button className="btn btn--negative btn--outline push-quarter--ends">Negative Button</button>&nbsp;
      <button className="btn btn--secondary btn--outline push-quarter--ends">Secondary Button</button>&nbsp;
      <button className="btn btn--secondary btn--outline blue-label push-quarter--ends">Secondary Blue Button</button>&nbsp;
      <br/><br/>

      <pre><code className="language-html">{`<button className="btn btn--outline">Primary Button</button>
<button className="btn btn--positive btn--outline">Positive Button</button>
<button className="btn btn--negative btn--outline">Negative Button</button>
<button className="btn btn--secondary btn--outline">Secondary Button</button>
<button className="btn btn--secondary btn--outline blue-label">Secondary Blue Button</button>`}</code></pre>
      <br/>

      <h4>Coloring - Transparent</h4>

      <button className="btn btn--transparent">Transparent Button</button>
      <br/><br/>
      <pre><code className="language-html">{`<button class="btn btn--transparent">Transparent Button</button>`}</code></pre>
      <br/>

      <h4>Icon Buttons</h4>

      <button className="btn push-quarter--ends"><i className="icon-cme-download"></i> Download Button</button>&nbsp;
      <button className="btn btn--secondary push-quarter--ends"><i className="fa fa-info"></i> Info Button</button>&nbsp;
      <button className="btn btn--positive push-quarter--ends"><i className="fa fa-plus"></i> Plus Button</button>&nbsp;
      <button className="btn btn--negative push-quarter--ends"><i className="fa fa-minus"></i> Minus Button</button>&nbsp;
      <button className="btn btn--transparent push-quarter--ends"><i className="fa fa-download fa-lg"></i></button>&nbsp;
      <button className="btn btn--link push-quarter--ends"><i className="fa fa-info"></i> Link Button</button>
      <br/><br/>
      <pre><code className="language-html">{`<button class="btn"><i class="icon-cme-download"></i> Download Button</button>
<button class="btn btn--secondary"><i class="fa fa-info"></i> Info Button</button>
<button class="btn btn--positive"><i class="fa fa-plus"></i> Plus Button</button>
<button class="btn btn--negative"><i class="fa fa-minus"></i> Minus Button</button>
<button class="btn btn--transparent"><i class="fa fa-download fa-lg"></i></button>
<button class="btn btn--link"><i class="fa fa-info"></i> Link Button</button>`}</code></pre>
      <br/>
      <h4>Disabled</h4>

      <button className="btn push-quarter--ends" disabled>Primary Button</button>&nbsp;
      <button className="btn btn--secondary push-quarter--ends" disabled>Secondary Button</button>&nbsp;
      <button className="btn btn--positive push-quarter--ends" disabled>Positive Button</button>&nbsp;
      <button className="btn btn--negative push-quarter--ends" disabled>Negative Button</button>&nbsp;
      <button className="btn btn--transparent push-quarter--ends" disabled>Transparent Button</button>&nbsp;
      <button className="btn btn--link push-quarter--ends" disabled>Link Button</button>
      <br/><br/>
      <pre><code className="language-html">{`<button class="btn" disabled>Primary Button</button>
<button class="btn btn--secondary" disabled>Secondary Button</button>
<button class="btn btn--positive" disabled>Positive Button</button>
<button class="btn btn--negative" disabled>Negative Button</button>
<button class="btn btn--transparent" disabled>Transparent Button</button>
<button class="btn btn--link" disabled>Link Button</button>`}</code></pre>
      <br/>

      <h3>Button Groups</h3>
      <h4 className="push-half--bottom">Single Select</h4>
      <p>The single select button group is represented by a series of radio buttons where the associated label for each radio button is styled to look like a button. Apply both the <code>btn-group</code> and <code>btn-group--single</code> classes to the containing element.</p>
      <p>Additionally, small and large variants of the single select button group are also available by applying the <code>btn-group--small</code> or <code>btn-group--large</code> class to the containing element as appropriate.</p>

      <div className="push-quarter--bottom clearfix">

        <div className="float--left push--right">
          <h6 className="push-half--bottom">Small</h6>
          <ul className="btn-group btn-group--single btn-group--small js-btn-group">
            <li className="btn-group-item">
              <input className="btn-group-item__input" id="button-group-single-select-trade-1" type="radio" name="button-group-single-select-example-1" value="button-group-single-select-trade-1" />
              <label className="btn-group-item__label" htmlFor="button-group-single-select-trade-1">Trade</label>
            </li>
            <li className="btn-group-item ">
              <input className="btn-group-item__input" id="button-group-single-select-spread-1" type="radio" name="button-group-single-select-example-1" value="button-group-single-select-spread-1" />
              <label className="btn-group-item__label" htmlFor="button-group-single-select-spread-1">Spread</label>
            </li>
          </ul>
        </div>

        <div className="float--left push--right">
          <h6 className="push-half--bottom">Default</h6>
          <ul className="btn-group btn-group--single js-btn-group">
            <li className="btn-group-item">
              <input className="btn-group-item__input" id="button-group-single-select-trade-2" type="radio" name="button-group-single-select-example-2" value="button-group-single-select-trade-2" />
              <label className="btn-group-item__label" htmlFor="button-group-single-select-trade-2">Trade</label>
            </li>
            <li className="btn-group-item">
              <input className="btn-group-item__input" id="button-group-single-select-spread-2" type="radio" name="button-group-single-select-example-2" value="button-group-single-select-spread-2" />
              <label className="btn-group-item__label" htmlFor="button-group-single-select-spread-2">Spread</label>
            </li>
          </ul>
        </div>

        <div className="float--left">
          <h6 className="push-half--bottom">Large</h6>
          <ul className="btn-group btn-group--single btn-group--large js-btn-group">
            <li className="btn-group-item">
              <input className="btn-group-item__input" id="button-group-single-select-trade-3" type="radio" name="button-group-single-select-example-3" value="button-group-single-select-trade-3" />
              <label className="btn-group-item__label" htmlFor="button-group-single-select-trade-3">Trade</label>
            </li>
            <li className="btn-group-item">
              <input className="btn-group-item__input" id="button-group-single-select-spread-3" type="radio" name="button-group-single-select-example-3" value="button-group-single-select-spread-3" />
              <label className="btn-group-item__label" htmlFor="button-group-single-select-spread-3">Spread</label>
            </li>
          </ul>
        </div>

      </div>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<!-- Single Select Button Group - Small -->
<ul class="btn-group btn-group--single btn-group--small">
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-group-single-select-trade-1" type="radio" name="button-group-single-select-example-1" value="button-group-single-select-trade-1" />
    <label class="btn-group-item__label" for="button-group-single-select-trade-1">Trade</label>
  </li>
  <li class="btn-group-item ">
    <input class="btn-group-item__input" id="button-group-single-select-spread-1" type="radio" name="button-group-single-select-example-1" value="button-group-single-select-spread-1" />
    <label class="btn-group-item__label" for="button-group-single-select-spread-1">Spread</label>
  </li>
</ul>

<!-- Single Select Button Group - Default -->
<ul class="btn-group btn-group--single">
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-group-single-select-trade-2" type="radio" name="button-group-single-select-example-2" value="button-group-single-select-trade-2" />
    <label class="btn-group-item__label" for="button-group-single-select-trade-2">Trade</label>
  </li>
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-group-single-select-spread-2" type="radio" name="button-group-single-select-example-2" value="button-group-single-select-spread-2" />
    <label class="btn-group-item__label" for="button-group-single-select-spread-2">Spread</label>
  </li>
</ul>

<!-- Single Select Button Group - Large -->
<ul class="btn-group btn-group--single btn-group--large">
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-group-single-select-trade-3" type="radio" name="button-group-single-select-example-3" value="button-group-single-select-trade-3" />
    <label class="btn-group-item__label" for="button-group-single-select-trade-3">Trade</label>
  </li>
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-group-single-select-spread-3" type="radio" name="button-group-single-select-example-3" value="button-group-single-select-spread-3" />
    <label class="btn-group-item__label" for="button-group-single-select-spread-3">Spread</label>
  </li>
</ul>`}</code></pre>

      <div className="display--block push-quarter--bottom">
        <h6 className="push-half--bottom">Single Select with Multiple Options</h6>
        <ul className="btn-group btn-group--single js-btn-group js-btn-group--responsive-example">
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-group-single-select-1" type="radio" name="button-group-single-select" value="button-group-single-select-1" />
            <label className="btn-group-item__label" htmlFor="button-group-single-select-1">Single Select</label>
          </li>
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-group-single-select-2" type="radio" name="button-group-single-select" value="button-group-single-select-2" />
            <label className="btn-group-item__label" htmlFor="button-group-single-select-2">Button Group</label>
          </li>
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-group-single-select-3" type="radio" name="button-group-single-select" value="button-group-single-select-3" />
            <label className="btn-group-item__label" htmlFor="button-group-single-select-3">With</label>
          </li>
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-group-single-select-4" type="radio" name="button-group-single-select" value="button-group-single-select-4" />
            <label className="btn-group-item__label" htmlFor="button-group-single-select-4">Multiple Options</label>
          </li>
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-group-single-select-5" type="radio" name="button-group-single-select" value="button-group-single-select-5" />
            <label className="btn-group-item__label" htmlFor="button-group-single-select-5">Example</label>
          </li>
        </ul>
      </div>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<ul class="btn-group btn-group--single">
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-group-single-select-1" type="radio" name="button-group-single-select" value="button-group-single-select-1" />
    <label class="btn-group-item__label" for="button-group-single-select-1">Single Select</label>
  </li>
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-group-single-select-2" type="radio" name="button-group-single-select" value="button-group-single-select-2" />
    <label class="btn-group-item__label" for="button-group-single-select-2">Button Group</label>
  </li>
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-group-single-select-3" type="radio" name="button-group-single-select" value="button-group-single-select-3" />
    <label class="btn-group-item__label" for="button-group-single-select-3">With</label>
  </li>
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-group-single-select-4" type="radio" name="button-group-single-select" value="button-group-single-select-4" />
    <label class="btn-group-item__label" for="button-group-single-select-4">Multiple Options</label>
  </li>
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-group-single-select-5" type="radio" name="button-group-single-select" value="button-group-single-select-5" />
    <label class="btn-group-item__label" for="button-group-single-select-5">Example</label>
  </li>
</ul>`}</code></pre>

      <br/>

      <div className="panel--callout panel--callout--blue-3">
        <h3 className="panel__heading">Important</h3>
        <ul className="list-dots">
          <li>Each radio button element in the button group must contain the same <code>name</code> attribute.</li>
          <li>Each <code>btn-group-item</code> must contain a radio button input element and a label element, where the input element contains a unique <code>id</code> and the label element is associated with the <code>id</code> of the input via the <code>for</code> attribute of the label.</li>
        </ul>
      </div>

      <br/>

      <h4>Responsive</h4>

      <p>When the width of the element containing the button group is not wide enough to display all buttons in the group without wrapping, the button group will convert automatically into a dropdown (provided it has been initialized as outlined below). By default, the width of the dropdown button will be determined dynamically based on the width of the widest option in the list of available options.</p>

      <p>Alternatively, you can apply a <code>btn-group--full-width</code> modifier class to the button group to make the button group span the full width of the containing element, as demonstrated below (select 480px from the dropdown).</p>

      <pre><code className="language-html">{`<ul class="btn-group btn-group--single btn-group--full-width js-btn-group">
  <li class="btn-group-item">
    ...
  </li>
</ul>`}
      </code></pre>

      <br />

      <select className="size-select">
        <option value="auto">Select a resolution</option>
        <option value="482">480px (xs)</option>
        <option value="770">768px (sm)</option>
        <option value="994">992px (md)</option>
        <option value="1202">1200px (lg)</option>
        <option value="1602">1600px (xlg)</option>
      </select>
      <br/><br/>
      <div className="iframe-container" style={{"height":"350px"}}>
        <iframe seamless srcDoc={`
          <html>
            <head>
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
              <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
              <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              <link rel="stylesheet" type="text/css" href="css/styleguide.css">
            </head>
            <body>

              <div class="push-half">
                <h5 class="push-quarter--bottom">Default Width</h5>
                <ul class="btn-group btn-group--single js-btn-group">
                  <li class="btn-group-item">
                    <input class="btn-group-item__input" id="button-group-single-select-1" type="radio" name="button-group-single-select-1" value="button-group-single-select-1" />
                    <label class="btn-group-item__label" for="button-group-single-select-1">Single Select</label>
                  </li>
                  <li class="btn-group-item">
                    <input class="btn-group-item__input" id="button-group-single-select-2" type="radio" name="button-group-single-select-1" value="button-group-single-select-2" />
                    <label class="btn-group-item__label" for="button-group-single-select-2">Button Group</label>
                  </li>
                  <li class="btn-group-item">
                    <input class="btn-group-item__input" id="button-group-single-select-3" type="radio" name="button-group-single-select-1" value="button-group-single-select-3" />
                    <label class="btn-group-item__label" for="button-group-single-select-3">With</label>
                  </li>
                  <li class="btn-group-item">
                    <input class="btn-group-item__input" id="button-group-single-select-4" type="radio" name="button-group-single-select-1" value="button-group-single-select-4" />
                    <label class="btn-group-item__label" for="button-group-single-select-4">Multiple Options</label>
                  </li>
                  <li class="btn-group-item">
                    <input class="btn-group-item__input" id="button-group-single-select-5" type="radio" name="button-group-single-select-1" value="button-group-single-select-5" />
                    <label class="btn-group-item__label" for="button-group-single-select-5">Example</label>
                  </li>
                </ul>
              </div>

              <div class="push-half">
                <h5 class="push-quarter--bottom">Full Width</h5>
                <ul class="btn-group btn-group--single btn-group--full-width js-btn-group">
                  <li class="btn-group-item">
                    <input class="btn-group-item__input" id="button-group-single-select-6" type="radio" name="button-group-single-select-2" value="button-group-single-select-6" />
                    <label class="btn-group-item__label" for="button-group-single-select-6">Single Select</label>
                  </li>
                  <li class="btn-group-item">
                    <input class="btn-group-item__input" id="button-group-single-select-7" type="radio" name="button-group-single-select-2" value="button-group-single-select-7" />
                    <label class="btn-group-item__label" for="button-group-single-select-7">Button Group</label>
                  </li>
                  <li class="btn-group-item">
                    <input class="btn-group-item__input" id="button-group-single-select-8" type="radio" name="button-group-single-select-2" value="button-group-single-select-8" />
                    <label class="btn-group-item__label" for="button-group-single-select-8">With</label>
                  </li>
                  <li class="btn-group-item">
                    <input class="btn-group-item__input" id="button-group-single-select-9" type="radio" name="button-group-single-select-2" value="button-group-single-select-9" />
                    <label class="btn-group-item__label" for="button-group-single-select-9">Multiple Options</label>
                  </li>
                  <li class="btn-group-item">
                    <input class="btn-group-item__input" id="button-group-single-select-10" type="radio" name="button-group-single-select-2" value="button-group-single-select-10" />
                    <label class="btn-group-item__label" for="button-group-single-select-10">Example</label>
                  </li>
                </ul>
              </div>

            </body>
            <script type="text/javascript" src="js/commonUI.js"></script>
            <script>
              function init() {
                commonUI.initializeButtonGroup();
              }
              window.onload = init;
            </script>
          </html>
        `}></iframe>
      </div>

      <br/>

      <br/>

      <h3 className="push-half--bottom">Multi Select</h3>
      <p>The multi select button group is represented by a series of checkboxes where the associated label for each checkbox is styled to look like a button.</p>
      <div className="display--block push-quarter--bottom">
        <ul className="btn-group js-btn-group">
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-1" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="button-1">Selected</label>
          </li>
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-2" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="button-2">Longer Selected</label>
          </li>
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-3" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="button-3">Selected</label>
          </li>
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-4" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="button-4">Longer Selected</label>
          </li>
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-5" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="button-5">Selected</label>
          </li>
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-6" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="button-6">Longer Selected</label>
          </li>
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-7" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="button-7">Selected</label>
          </li>
          <li className="btn-group-item">
            <input className="btn-group-item__input" id="button-8" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="button-8">Very Long Selected</label>
          </li>
        </ul>
      </div>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<ul class="btn-group js-btn-group">
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-1" type="checkbox"/>
    <label class="btn-group-item__label" for="button-1">Selected</label>
  </li>
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-2" type="checkbox"/>
    <label class="btn-group-item__label" for="button-2">Longer Selected</label>
  </li>
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-3" type="checkbox"/>
    <label class="btn-group-item__label" for="button-3">Selected</label>
  </li>
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-4" type="checkbox"/>
    <label class="btn-group-item__label" for="button-4">Longer Selected</label>
  </li>
  <li class="btn-group-item">
  <input class="btn-group-item__input" id="button-5" type="checkbox"/>
  <label class="btn-group-item__label" for="button-5">Selected</label>
  </li>
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-6" type="checkbox"/>
    <label class="btn-group-item__label" for="button-6">Longer Selected</label>
  </li>
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-7" type="checkbox"/>
    <label class="btn-group-item__label" for="button-7">Selected</label>
  </li>
  <li class="btn-group-item">
    <input class="btn-group-item__input" id="button-8" type="checkbox"/>
    <label class="btn-group-item__label" for="button-8">Very Long Selected</label>
  </li>
</ul>`}</code></pre>
      <br />
      <h3 className="push-half--bottom">Draggable Multi Select</h3>
      <p>The draggable multi select button group is represented by a series of checkboxes where the associated label for each checkbox is styled to look like a button. To make the button draggable add <code>draggable</code> as an attribute. To position the draggable icon to the left use the <code>draggable__icon--left</code> modifier</p>

      <div className="display--block push-quarter--bottom">
        <ul className="btn-group js-btn-group">
          <li className="btn-group-item" data-id="0">
            <input className="btn-group-item__input" id="draggable-button-1" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-1" draggable>
              Button 1
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item" data-id="1">
            <input className="btn-group-item__input" id="draggable-button-2" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-2" draggable>
              Button 2
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item" data-id="2">
            <input className="btn-group-item__input" id="draggable-button-3" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-3" draggable>
              Button 3
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item" data-d="3">
            <input className="btn-group-item__input" id="draggable-button-4" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-4" draggable>
              Button 4
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item" data-id="4">
            <input className="btn-group-item__input" id="draggable-button-5" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-5" draggable>
              Button 5
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item" data-id="5">
            <input className="btn-group-item__input" id="draggable-button-6" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-6" draggable>
              Button 6
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item" data-id="6">
            <input className="btn-group-item__input" id="draggable-button-7" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-7" draggable>
              Button 7
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item" data-id="7">
            <input className="btn-group-item__input" id="draggable-button-8" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-8" draggable>
              Button 8
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
        </ul>
      </div>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<ul class="btn-group js-btn-group">
  <li class="btn-group-item" id="0">
    <input class="btn-group-item__input" id="draggable-button-1" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-1" draggable>
      Button 1
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item" id="1">
    <input class="btn-group-item__input" id="draggable-button-2" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-2" draggable>
      Button 2
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item" id="2">
    <input class="btn-group-item__input" id="draggable-button-3" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-3" draggable>
      Button 3
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item" id="3">
    <input class="btn-group-item__input" id="draggable-button-4" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-4" draggable>
      Button 4
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item" id="4">
    <input class="btn-group-item__input" id="draggable-button-5" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-5" draggable>
      Button 5
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item" id="5">
    <input class="btn-group-item__input" id="draggable-button-6" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-6" draggable>
      Button 6
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item" id="6">
    <input class="btn-group-item__input" id="draggable-button-7" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-7" draggable>
      Button 7
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item" id="7">
    <input class="btn-group-item__input" id="draggable-button-8" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-8" draggable>
      Button 8
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
</ul>`}</code></pre>
      <br />
      <h3 className="push-half--bottom">Draggable Multi Select Full Width</h3>
      <p>The draggable multi select button group is represented by a series of checkboxes where the associated label for each checkbox is styled to look like a button. To make the button draggable add <code>draggable</code> as an attribute. Add <code>btn-group-item--full-width</code> as a helper to set each button to the full width of the container it is in.</p>
      <div className="display--block push-quarter--bottom grid__col-sm-4">
        <ul className="btn-group js-btn-group">
          <li className="btn-group-item btn-group-item--full-width" data-id="0">
            <input className="btn-group-item__input" id="draggable-button-full-width-1" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-full-width-1" draggable>
              Button 1
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item btn-group-item--full-width" data-id="1">
            <input className="btn-group-item__input" id="draggable-button-full-width-2" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-full-width-2" draggable>
              Button 2
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item btn-group-item--full-width" data-id="2">
            <input className="btn-group-item__input" id="draggable-button-full-width-3" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-full-width-3" draggable>
              Button 3
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item btn-group-item--full-width" data-id="3">
            <input className="btn-group-item__input" id="draggable-button-full-width-4" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-full-width-4" draggable>
              Button 4
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item btn-group-item--full-width" data-id="4">
            <input className="btn-group-item__input" id="draggable-button-full-width-5" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-full-width-5" draggable>
              Button 5
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item btn-group-item--full-width" data-id="5">
            <input className="btn-group-item__input" id="draggable-button-full-width-6" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-full-width-6" draggable>
              Button 6
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item btn-group-item--full-width" data-id="6">
            <input className="btn-group-item__input" id="draggable-button-full-width-7" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-full-width-7" draggable>
              Button 7
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
          <li className="btn-group-item btn-group-item--full-width" data-id="7">
            <input className="btn-group-item__input" id="draggable-button-full-width-8" type="checkbox"/>
            <label className="btn-group-item__label" htmlFor="draggable-button-full-width-8" draggable>
              Button 8
              <i className="icon-cme-drag-drop"></i>
            </label>
          </li>
        </ul>
      </div>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<ul class="btn-group js-btn-group">
  <li class="btn-group-item btn-group-item--full-width" id="0">
    <input class="btn-group-item__input" id="draggable-button-full-width-1" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-full-width-1" draggable>
      Button 1
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item btn-group-item--full-width" id="0">
    <input class="btn-group-item__input" id="draggable-button-full-width-2" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-full-width-2" draggable>
      Button 2
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item btn-group-item--full-width" id="0">
    <input class="btn-group-item__input" id="draggable-button-full-width-3" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-full-width-3" draggable>
      Button 3
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item btn-group-item--full-width" id="0">
    <input class="btn-group-item__input" id="draggable-button-full-width-4" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-full-width-4" draggable>
      Button 4
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item btn-group-item--full-width" id="0">
    <input class="btn-group-item__input" id="draggable-button-full-width-5" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-full-width-5" draggable>
      Button 5
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item btn-group-item--full-width" id="0">
    <input class="btn-group-item__input" id="draggable-button-full-width-6" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-full-width-6" draggable>
      Button 6
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item btn-group-item--full-width" id="0">
    <input class="btn-group-item__input" id="draggable-button-full-width-7" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-full-width-7" draggable>
      Button 7
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
  <li class="btn-group-item btn-group-item--full-width" id="0">
    <input class="btn-group-item__input" id="draggable-button-full-width-8" type="checkbox"/>
    <label class="btn-group-item__label" for="draggable-button-full-width-8" draggable>
      Button 8
      <i class="icon-cme-drag-drop"></i>
    </label>
  </li>
</ul>`}</code></pre>
    <br />
      <ul className="panel--callout panel--callout--grey-4">
        <li className="panel__body">
          <strong>Note:</strong><br />
          * The button-group-items are inputs-checkboxes that are styled to look like buttons. <br />
          * Each button-group-item must have a unique id-for combination.
        </li>
      </ul>
      <br />
      <p>Button Groups are JavaScript enabled and if you want to listen to the click events you must do the following:</p>
      <pre><code className="language-js">{`// Initialize the button group
commonUI.initializeButtonGroup();

// Target your button group and store it's reference in a var
var buttonGroup = document.getElementsByClassName('btn-group')[0];

// Listen to the specific event and specify what you want to happen within a function
buttonGroup.addEventListener('apply.commonui.buttonGroup', function() {
  // Example - If we wanted to to know the ids of the button-group-items which have been selected:

  // Starting empty array
  var selectedButtonsArray = [];
  // Grab all buttons which have been selected
  var allSelectedButtons = buttonGroup.querySelectorAll('input[type=checkbox]:checked');
  // For each selected button, add it's id value to the array
  for (var i = 0; i < allSelectedButtons.length; i++) {
    selectedButtonsArray.push(allSelectedButtons[i].id)
  };
  console.log(selectedButtonsArray);
  // See console for example results
});`}
      </code></pre>
      <br />
      <hr />
      </section>
    )
  }
}

export default Buttons



// WEBPACK FOOTER //
// ./styleguide/components/sections/Buttons.js